import { RefundType } from "@/api/paymentApi";

export const DefaultStatusFilterOption = [
    {
        name: "SUCCESS",
    },
    {
        name: "FAILED",
    },
    {
        name: "CANCELED",
    },
    {
        name: "PENDING",
    },
    {
        name: "RETURNED",
    },
];

export const DefaultTypeFilterOption = [
    {
        name: "DEBIT",
    },
    {
        name: "REFUND",
    },
    {
        name: "PAYMENT_RETURN"
    },
    {
        name: "PAYMENT_REVERSAL"
    },
    {
        name: "CHARGEBACK_CREDIT"
    },
    {
        name: "CHARGEBACK_DEBIT"
    },
    {
        name: "RESERVE"
    },
    {
        name: "RESERVE_TRANSFER"
    }
];

export const DefaultRefundTypeFilterOption = [
  RefundType.REFUND, RefundType.PAYMENTRETURN, RefundType.PAYMENTREVERSAL
]

export const DefaultAlertTypeFilterOption = [
    {
        name: "all",
    },
    {
        name: "new_dispute",
    },
    {
        name: "dispute_reminders",
    },
    {
        name: "additional_evidence"
    },
    {
        name: "compliance_form"
    },
    {
        name: "negative_balance"
    },
    {
        name: "fund_added"
    }
]

export const PaymentMethodFilterOption = [
    {
        name: "CARD",
    },
    {
        name: "APPLE_PAY",
    },
    {
        name: "GOOGLE_PAY",
    },
    {
        name: "ACH_DEBIT",
    },
    {
        name: "BACS_DEBIT",
    },
    {
        name: "SEPA_DEBIT",
    },
];

export const AmountFilterOption = [
    {
        name: "equals",
    },
    {
        name: "between",
    },
    {
        name: "greater_than",
    },
    {
        name: "less_than",
    },
]

export const FilterEntity = {
    Type: "typeFilter",
    PaymentMethod: "paymentMethodFilter",
    Status: "statusFilter",
    Amount: 'amountFilter'
}

